import type { TFunction } from 'i18next';
import type { RecentCollectCollectionSummary } from '../services/api/collectDataService';

const OWNER_DISPLAY_PLACEHOLDERS = new Set([
    'The collection owner',
    'Le responsable de la collecte',
]);

export type CollectCardOwnerContext = {
    /** ID utilisateur connecté — aligné sur owner_id renvoyé par l’API. */
    userId?: string | null;
    userFullname?: string | null;
};

function normalizeOwnerDisplayName(raw: string | null | undefined): string {
    const trimmed = (raw ?? '').trim();
    if (!trimmed || OWNER_DISPLAY_PLACEHOLDERS.has(trimmed)) return '';
    return trimmed;
}

/** Libellé propriétaire pour cartes collecte (accueil / bibliothèque). */
export function resolveCollectCardOwnerLabel(
    col: RecentCollectCollectionSummary,
    t: TFunction,
    ctx?: CollectCardOwnerContext,
): string {
    const ownerName = normalizeOwnerDisplayName(col.owner_display_name);
    const userId = ctx?.userId?.trim() || '';
    const ownerId = col.owner_id?.trim() || '';

    const viewingAsGuest = Boolean(col.opened_as_contributor || col.is_collection_co_owner);
    const isPrimaryOwner =
        (col.is_primary_owner === true || (ownerId && userId && ownerId === userId)) &&
        !viewingAsGuest;

    if (isPrimaryOwner) {
        return t('words.me', { defaultValue: 'Me' });
    }

    if (ownerName) {
        const meName = ctx?.userFullname?.trim();
        if (meName && ownerName === meName) {
            return t('words.me', { defaultValue: 'Me' });
        }
        return ownerName;
    }

    return t('words.owner', { defaultValue: 'Owner' });
}
